import { Box, Grid, Typography, Theme } from '@mui/material';
import { SubHeading } from '../investors/components';
import React from 'react';
import { Item, ItemDetails, Gridstyles } from './index';
import { Applicant } from '../../redux-store/types/api-types';
import { formatShortDate } from '../../utils/date';
import { SxProps } from '@mui/system';
import { applicantStatusMasters, YES_NO_BOOLEAN_MASTER } from '../../utils/constant';
import { countryDeclaration } from '../declaration';
import { checkValidationBasedOnDate } from '../../utils/utilityFunctions';
import { useFeatureToggles } from '../../utils/useDataMdms';

export const KeyValue = ({
  title,
  description,
  amount,
  sx = {},
  fullWidth = false,
}: {
  title: string | undefined;
  description?: string | number | boolean | null;
  amount?: number | null | undefined | string;
  sx?: SxProps<Theme>;
  fullWidth?: boolean;
}): JSX.Element => {
  return (
    <Grid item xs={12} sm={6} md={fullWidth ? 12 : 6}>
      <Item sx={sx}>{title}</Item>
      <ItemDetails> {description ? description : '-'}</ItemDetails>
      {!!amount && amount !== 0 && <Item sx={{ pt: 0 }}> {amount}</Item>}
    </Grid>
  );
};

export default function ContributorDetails({
  applicants = [],
  modeOfHolding,
  createdAt,
}: {
  applicants: Partial<Applicant>[];
  modeOfHolding: string;
  createdAt: string;
}): JSX.Element {
  const { toggler } = useFeatureToggles();
  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}
        mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
              <Typography
                component="h2"
                sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main', m: 0 }}>
                Contributor Details
              </Typography>
              <Typography
                sx={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: 'text.secondary',
                }}>
                Mode of Holding:{' '}
                <Typography
                  component="span"
                  sx={{
                    fontWeight: 500,
                    fontSize: '16px',
                    color: 'rgba(0, 0, 0, 0.6)',
                    letterSpacing: '0.4px',
                    ml: 0.5,
                    textTransform: 'capitalize',
                  }}>
                  {modeOfHolding === 'either or survivor' ? 'Joint' : modeOfHolding || 'Single'}
                </Typography>
              </Typography>
            </Grid>
            {applicants.map((applicant, index: number) => {
              const title = [
                'First Applicant Details',
                'Second Applicant Details',
                'Third Applicant Details',
              ][index];
              return (
                <React.Fragment key={applicant.id}>
                  <SubHeading
                    sx={{
                      color: 'common.black',
                      letterSpacing: 0.5 + 'px',
                      padding: { xs: '10px 10px', sm: '10px 30px' },
                    }}>
                    {title}
                  </SubHeading>
                  <Gridstyles>
                    <Grid
                      item
                      container
                      pb={5}
                      rowSpacing={6}
                      columnSpacing={13}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start">
                      <KeyValue title={'Name'} description={applicant.name} />
                      <KeyValue title={'Gender'} description={applicant.gender} />
                      <KeyValue
                        title={'Date Of Birth'}
                        description={formatShortDate(applicant.dateOfBirth)}
                      />
                      <KeyValue
                        title={'Father/Spouse Name'}
                        description={applicant.fatherOrSpouseName}
                      />
                      <KeyValue title={'Mother Name'} description={applicant.motherName} />
                      <KeyValue title={'PAN'} description={applicant.panNo} />
                      <KeyValue
                        title={'Status'}
                        description={
                          applicant.status
                            ? applicantStatusMasters[applicant.status]
                            : applicant.status
                        }
                      />
                      <KeyValue
                        title={'Country/ Nationality'}
                        description={applicant.nationality}
                      />
                      {checkValidationBasedOnDate(
                        createdAt,
                        toggler?.dateFeatureToggles?.borderCountryDeclarationDate || ''
                      ) && (
                        <KeyValue
                          title={countryDeclaration}
                          description={
                            YES_NO_BOOLEAN_MASTER[
                              applicant?.borderCountryDeclaration?.toString() || ''
                            ]
                          }
                        />
                      )}
                      {index !== 0 && (
                        <KeyValue
                          title={'RelationShip With First Applicant'}
                          description={applicant.relationShipWithFirstApplicant}
                        />
                      )}
                    </Grid>
                  </Gridstyles>
                </React.Fragment>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
